module.exports = __webpack_public_path__ + "img/野餐.d6f23703.png";